import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  platformBrowser().bootstrapModule(AppModule)
    .catch(err => console.log(err));
} else {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
}
